import { applyTimeToPatient, buildWaitLists, addPatientToList, removePatientFromLists} from 'Helper/listHelpers'
import _ from 'lodash'

function nurseDashboardReducer(state = {}, action = {}) {
  let lists = {}
  let waitingInjectionWindow
  let withInjectionStaffWindow
  let waitingExcuseWindow

  switch (action.type) {
    case 'CLEAR_PURCHASEORDERS_WIDGET':
      return {
        ...state,
        purchaseOrdersWindow: null
      }
    case 'INIT_PURCHASEORDERS_WIDGET':
      return {
        ...state,
        purchaseOrdersWindow: {}
      }
    case 'CLEAR_SKINTESTLIST_WIDGET':
      return {
        ...state,
        skinTestListWindow: null
      }
    case 'INIT_SKINTESTLIST_WIDGET':
      return {
        ...state,
        skinTestListWindow: {}
      }
    case 'CLEAR_VIALTESTLIST_WIDGET':
      return {
        ...state,
        vialTestListWindow: null
      }
    case 'INIT_VIALTESTLIST_WIDGET':
      return {
        ...state,
        vialTestListWindow: {}
      }
    case 'CLEAR_INJECTIONLIST_WIDGET':
      return {
        ...state,
        injectionListWindow: null
      }
    case 'INIT_INJECTIONLIST_WIDGET':
      return {
        ...state,
        injectionListWindow: {}
      }
    case 'STORE_ME_READ_ALL':
    case 'STORE_ME_UPDATE':
      return {
        ...state,
        userTimezone: action.result?.timezone
      }
    case 'RESET_WAITLIST_LISTS':
      return {
        ...state,
        withInjectionStaffWindow: [],
        waitingInjectionWindow: [],
        waitingExcuseWindow: []
      }
    case 'STORE_WAITLIST_UPDATE':
    case 'STORE_WAITLIST_SEARCH':
    case 'STORE_WAITLIST_STREAM':
    case 'STORE_CLINIC_WAITLIST_STREAM':
      lists = buildWaitLists(action.result, _.cloneDeep(state))
      return {
        ...state,
        withInjectionStaffWindow: lists.withInjectionStaffWindow,
        waitingInjectionWindow: lists.waitingInjectionWindow,
        waitingExcuseWindow: lists.waitingExcuseWindow
      }
    case 'STORE_PATIENT_ENCOUNTER_CREATE':
    case 'STORE_PATIENT_ENCOUNTER_UPDATE':
      waitingInjectionWindow = [...(state.waitingInjectionWindow || [])]
      withInjectionStaffWindow = [...(state.withInjectionStaffWindow || [])]
      waitingExcuseWindow = [...(state.waitingExcuseWindow || [])]

      // first delete it from any lists
      lists = removePatientFromLists(action.result, { waitingInjectionWindow, withInjectionStaffWindow, waitingExcuseWindow })
      // then add it back to the correct list
      lists = addPatientToList(action.result, lists)
      return {
        ...state,
        withInjectionStaffWindow: lists.withInjectionStaffWindow,
        waitingInjectionWindow: lists.waitingInjectionWindow,
        waitingExcuseWindow: lists.waitingExcuseWindow
      }
    case 'STORE_PATIENT_ENCOUNTER_DELETE':
      waitingInjectionWindow = [...(state.waitingInjectionWindow || [])]
      withInjectionStaffWindow = [...(state.withInjectionStaffWindow || [])]
      waitingExcuseWindow = [...(state.waitingExcuseWindow || [])]

      lists = removePatientFromLists(action.result, { withInjectionStaffWindow, waitingInjectionWindow, waitingExcuseWindow })

      return {
        ...state,
        // nothing added, only removed so sorting isnt needed
        withInjectionStaffWindow: lists.withInjectionStaffWindow,
        waitingInjectionWindow: lists.waitingInjectionWindow,
        waitingExcuseWindow: lists.waitingExcuseWindow
      }
    case 'UPDATE_TIME':
      // current state object mapped to new object
      waitingInjectionWindow = [...(state.waitingInjectionWindow || [])]
      withInjectionStaffWindow = [...(state.withInjectionStaffWindow || [])]
      waitingExcuseWindow = [...(state.waitingExcuseWindow || [])]

      waitingInjectionWindow = waitingInjectionWindow.map(patient => applyTimeToPatient(patient, state.userTimezone))
      waitingExcuseWindow = waitingExcuseWindow.map(patient => applyTimeToPatient(patient, state.userTimezone))
      withInjectionStaffWindow = withInjectionStaffWindow.map(patient => applyTimeToPatient(patient, state.userTimezone))

      return {
        ...state,
        // all times changed equally so no sorting needed
        withInjectionStaffWindow,
        waitingInjectionWindow,
        waitingExcuseWindow
      }
    default:
      return state
  }
}

export default nurseDashboardReducer
